/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Project_FileInputs */

const en_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Project File`)
};

const fr_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le fichier de projet`)
};

const de_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei auswählen`)
};

const it_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona file di progetto`)
};

const ru_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл проекта`)
};

const es_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo de proyecto`)
};

const zh_cn2_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择项目文件`)
};

const ja_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトファイルを選択`)
};

const hi_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल का चयन करें`)
};

const pt_pt2_select_project_file = /** @type {(inputs: Select_Project_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o arquivo do projeto`)
};

/**
* | output |
* | --- |
* | "Select Project File" |
*
* @param {Select_Project_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_project_file = /** @type {((inputs?: Select_Project_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Project_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_project_file(inputs)
	if (locale === "de") return de_select_project_file(inputs)
	if (locale === "it") return it_select_project_file(inputs)
	if (locale === "ru") return ru_select_project_file(inputs)
	if (locale === "es") return es_select_project_file(inputs)
	if (locale === "zh-CN") return zh_cn2_select_project_file(inputs)
	if (locale === "ja") return ja_select_project_file(inputs)
	if (locale === "hi") return hi_select_project_file(inputs)
	if (locale === "pt-PT") return pt_pt2_select_project_file(inputs)
	return en_select_project_file(inputs)
});